<div class="popup-container">
  
  <div class="popup-header">
    <h2>Configure Facebook Pages</h2>
    <p class="subtitle">Set up your integration settings and authentication</p>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  
  <div class="instructions-box">
    <p class="instructions-title">
      <mat-icon style="color: #310737;">info</mat-icon> Setup Instructions
    </p>
    <p class="instructions-text">
      Create a Facebook App in the Developer Console and obtain your App ID, App Secret, and Page Access Token.
    </p>
    <a href="https://developers.facebook.com/" target="_blank" class="doc-link">
      <mat-icon inline>launch</mat-icon> Facebook Developer Console
    </a>
  </div>

 
<form class="form-section" #form="ngForm" (ngSubmit)="save()" novalidate>

  <div class="form-field">
    <label for="appId">App ID *</label>
    <input
      id="appId"
      type="text"
      placeholder="Your Facebook App ID"
      name="appId"
      [(ngModel)]="formData.appId"
      required
      #appId="ngModel"
    />
    <div class="error" *ngIf="appId.invalid && appId.touched">App ID is required</div>
  </div>

  <div class="form-field">
    <label for="appSecret">App Secret *</label>
    <input
      id="appSecret"
      type="text"
      placeholder="Your Facebook App Secret"
      name="appSecret"
      [(ngModel)]="formData.appSecret"
      required
      #appSecret="ngModel"
    />
    <div class="error" *ngIf="appSecret.invalid && appSecret.touched">App Secret is required</div>
  </div>

  <div class="form-field">
    <label for="pageToken">Page Access Token *</label>
    <input
      id="pageToken"
      type="text"
      placeholder="Page Access Token"
      name="pageToken"
      [(ngModel)]="formData.pageToken"
      required
      #pageToken="ngModel"
    />
    <div class="error" *ngIf="pageToken.invalid && pageToken.touched">Page Access Token is required</div>
  </div>

  <div class="form-field">
    <label for="verifyToken">Webhook Verify Token</label>
    <input
      id="verifyToken"
      type="text"
      placeholder="Webhook verification token"
      name="verifyToken"
      [(ngModel)]="formData.verifyToken"
    />
  </div>

  
  <div class="dialog-footer">
   <button mat-stroked-button color="basic" class="cancel-btn" (click)="close()" type="button">
  Cancel
</button>

<button mat-flat-button class="custom-save-btn" [disabled]="form.invalid" type="submit">
  Save Configuration
</button>

  </div>
</form>

